import httpClient from './http-client/http-client';
import URLS from './app-urls';
import getConfig from '../config';

const { nonce, jwtUrl, configUrl } = getConfig();

const getUrl = url => httpClient.getAuthUrl({
    authUrl: URLS.AUTH,
    nonce,
    jwtUrl,
    configUrl,
    redirectUrl: url,
});

export default {
    TEMPLATE: getUrl(URLS.TEMPLATE),
    EDIT: id => getUrl(URLS.EDIT(id)),
    PUBLISH: (videoId, renderingDuration = 0) => getUrl(URLS.PUBLISH(videoId, renderingDuration)),
    FAQ: getUrl(URLS.FAQ),
    PRICING: getUrl(URLS.PRICING),
    BILLING: getUrl(URLS.BILLING),
};
